import React, { useState } from "react";
import ToggleSwitch from "../../../../components/ios-radio-button/ToggleSwitch";
import UpdateButton from "./UpdateButton";
import { disableThisVendor } from "../../../../services/vendor/vendor.service";

const ManageVendorStatus = ({
  selectedItem,
  isRender,
  setIsRender,
  setSelectedItem,
}) => {
  const [loading, setLoading] = useState(false);

  const handleUpdate = async (id) => {
    setLoading(true);
    try {
      const res = await disableThisVendor({
        id,
        disabled: selectedItem?.disabled,
        googleShopping: selectedItem?.googleShopping,
        dynamicPricing: selectedItem?.dynamicPricing,
      });
      if (res?.data?.message) {
        setLoading(false);
        setIsRender(!isRender);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  return (
    <div className="  d-flex flex-column gap-10">
      <div className=" px-3 d-flex justify-content-between align-center gap-5">
        <span>
          Vendor Status: {selectedItem?.disabled ? "Disabled" : "Enabled"}
        </span>
        <span>
          <ToggleSwitch
            checked={selectedItem?.disabled}
            onChange={(e) => {
              setSelectedItem({
                ...selectedItem,
                disabled: e.target.checked,
              });
            }}
            Name={"disabled"}
          />
        </span>
      </div>
      <hr />
      <div className=" px-3 d-flex justify-content-between align-center gap-5">
        <span>
          Google Shopping:{" "}
          {selectedItem?.googleShopping ? "Enabled" : "Disabled"}
        </span>
        <span>
          <ToggleSwitch
            checked={selectedItem?.googleShopping}
            onChange={(e) => {
              setSelectedItem({
                ...selectedItem,
                googleShopping: e.target.checked,
              });
            }}
            Name={"googleShopping"}
          />
        </span>
      </div>
      <hr />
      <div className=" px-3 d-flex justify-content-between align-center gap-5">
        <span>
          Dynamic Pricing:{" "}
          {selectedItem?.dynamicPricing ? "Enabled" : "Disabled"}
        </span>
        <span>
          <ToggleSwitch
            checked={selectedItem?.dynamicPricing}
            onChange={(e) => {
              setSelectedItem({
                ...selectedItem,
                dynamicPricing: e.target.checked,
              });
            }}
            Name={"dynamicPricing"}
          />
        </span>
      </div>
      <UpdateButton
        position="fixed"
        brand={selectedItem?.fullName}
        loading={loading}
        onClick={() => handleUpdate(selectedItem?._id)}
      />
    </div>
  );
};

export default ManageVendorStatus;
